module.exports = __webpack_public_path__ + "img/affect-and-emotion.76e5465a.svg";